// Product Item Color Pills
document.addEventListener('DOMContentLoaded', function() {
  initProductItemColorPills();
  
  // Add CSS for active color pills
  addColorPillStyles();
});

// Also initialize color pills when Shopify sections are loaded
// This ensures they work in dynamically loaded sections like recommended products
document.addEventListener('shopify:section:load', function(event) {
  initProductItemColorPills();
});

function addColorPillStyles() {
  // Only add styles if they don't exist yet
  if (!document.getElementById('color-pill-styles')) {
    const styleElement = document.createElement('style');
    styleElement.id = 'color-pill-styles';
    styleElement.textContent = `
      .product-item__color-pill.active {
        outline-offset: 1px;
        transform: scale(1.1);
        z-index: 1;
      }
    `;
    document.head.appendChild(styleElement);
  }
}

function initProductItemColorPills() {
  const colorPills = document.querySelectorAll('.product-item__color-pill:not(.product-item__color-pill--more)');
  
  colorPills.forEach(pill => {
    // Remove existing event listeners to prevent duplicates
    pill.removeEventListener('click', handleColorPillClick);
    // Add new event listener
    pill.addEventListener('click', handleColorPillClick);
  });
}

// Separate the click handler function for better organization
function handleColorPillClick(e) {
  e.preventDefault();
  
  // Get the variant image URL
  const variantImageUrl = this.getAttribute('data-variant-image');
  if (!variantImageUrl) return;
  
  // Find the product item container
  const productItem = this.closest('.product-item');
  if (!productItem) return;
  
  // Find the product image - try both with and without the --one suffix
  // This handles both cases: when second image hover is enabled or disabled
  let productImage = productItem.querySelector('.product-item__image--one .image__img');
  
  // If the first selector doesn't find an image, try the simpler selector for when second image hover is disabled
  if (!productImage) {
    productImage = productItem.querySelector('.product-item__image .image__img');
  }
  
  if (productImage) {
    // Change the image source to the variant image
    productImage.setAttribute('srcset', variantImageUrl);
    productImage.setAttribute('src', variantImageUrl);
    
    // Set all pills in this product to inactive and make this one active
    const allPills = productItem.querySelectorAll('.product-item__color-pill');
    allPills.forEach(p => p.classList.remove('active'));
    this.classList.add('active');
    
    // Dispatch a custom event that other scripts might listen for
    const event = new CustomEvent('product:variant:changed', {
      detail: {
        variantId: this.getAttribute('data-variant-id'),
        productHandle: this.getAttribute('data-product-handle'),
        colorValue: this.getAttribute('data-color-value')
      },
      bubbles: true
    });
    this.dispatchEvent(event);
  }
}

// Also listen for Swiper initialization events to reinitialize pills after carousel is loaded
document.addEventListener('swiper:initialized', function() {
  setTimeout(initProductItemColorPills, 100);
});

// Add a mutation observer to detect when new product items are added to the DOM
const productObserver = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    if (mutation.addedNodes.length) {
      // Check if any added nodes contain color pills
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1 && (node.classList && node.classList.contains('product-item') || 
            node.querySelector && node.querySelector('.product-item__color-pill'))) {
          // Initialize color pills in this new node
          setTimeout(initProductItemColorPills, 100);
        }
      });
    }
  });
});

// Start observing the document body for changes
productObserver.observe(document.body, {
  childList: true,
  subtree: true
});

// Filter Drawer Observer
document.addEventListener('DOMContentLoaded', function() {
  // Watch for filter drawer panel becoming active
  const filterDrawerObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const target = mutation.target;
        if (target.classList.contains('filter-drawer__panel') && target.classList.contains('active')) {
          // Filter drawer has been opened
          document.dispatchEvent(new CustomEvent('filter:drawer:opened'));
        }
      }
    });
  });
  
  // Find all filter drawer panels
  const filterPanels = document.querySelectorAll('.filter-drawer__panel');
  filterPanels.forEach(function(panel) {
    filterDrawerObserver.observe(panel, { attributes: true });
  });
});

// Filter Tabs Functionality
document.addEventListener('DOMContentLoaded', function() {
  initFilterTabs();
});

// Initialize filter tabs when filter drawer is opened
document.addEventListener('filter:drawer:opened', function() {
  setTimeout(() => {
    initFilterTabs();
    updateFilterTabCounts(); // Update counts when drawer is opened
  }, 50);
});

function initFilterTabs() {
  const tabTriggers = document.querySelectorAll('[data-tab-trigger]');
  const tabPanels = document.querySelectorAll('[data-tab-panel]');
  
  if (!tabTriggers.length) return;
  
  tabTriggers.forEach(trigger => {
    // Remove existing event listeners to prevent duplicates
    trigger.removeEventListener('click', handleTabClick);
    // Add new event listener
    trigger.addEventListener('click', handleTabClick);
  });
}

function handleTabClick() {
  const tabId = this.getAttribute('data-tab-trigger');
  const tabTriggers = document.querySelectorAll('[data-tab-trigger]');
  const tabPanels = document.querySelectorAll('[data-tab-panel]');
  
  // Deactivate all tabs
  tabTriggers.forEach(t => t.classList.remove('active'));
  tabPanels.forEach(p => p.classList.remove('active'));
  
  // Activate selected tab
  this.classList.add('active');
  document.querySelector(`[data-tab-panel="${tabId}"]`).classList.add('active');
}

// Custom event listener for filter updates
document.addEventListener('collection:updated', function() {
  // Give time for the DOM to update before updating the tab counts
  setTimeout(updateFilterTabCounts, 100);
});

// Listen for filter removal events
document.addEventListener('filters:filter-removed', function() {
  // Give time for the DOM to update before updating the tab counts
  setTimeout(updateFilterTabCounts, 100);
});

// Listen for changes on filter inputs
document.addEventListener('change', function(e) {
  // Check if the changed element is a filter input inside the filter drawer
  if (e.target.closest('.filter-drawer') && 
      (e.target.type === 'checkbox' || e.target.type === 'radio')) {
    // Update counts immediately
    updateFilterTabCounts();
  }
});

// Function to update the filter tab counts
function updateFilterTabCounts() {
  const tabsContainer = document.querySelector('[data-filter-tabs-container]');
  if (!tabsContainer) return; // Exit if the filter drawer isn't open
  
  const tabTriggers = document.querySelectorAll('[data-tab-trigger]');
  
  tabTriggers.forEach(trigger => {
    const filterLabel = trigger.getAttribute('data-tab-trigger');
    const tabPanel = document.querySelector(`[data-tab-panel="${filterLabel}"]`);
    
    if (!tabPanel) return;
    
    // Count active filters in this tab panel
    const activeFilters = tabPanel.querySelectorAll('input:checked').length;
    
    // Find or create the count element
    let countElement = trigger.querySelector('.filter-drawer__tabs-count');
    
    if (activeFilters > 0) {
      // If there are active filters, show the count
      if (!countElement) {
        countElement = document.createElement('span');
        countElement.className = 'filter-drawer__tabs-count';
        trigger.querySelector('.filter-drawer__tabs-button').appendChild(countElement);
      }
      countElement.textContent = activeFilters;
    } else {
      // If no active filters, remove the count element if it exists
      if (countElement) {
        countElement.remove();
      }
    }
  });
} 